/**
 * 接口汇总
 */
import {get, post} from '../request/http'

// demo
export const testGetUrl = () => {
    return get('/admin/login/index.html')
}
export const testPostUrl = (option) => {
    return post('/admin/login/index.html', option)
}

// 订单
export const getFeOrderList = (param) => {
    return get('/api/fe/orders/list', {params: param})
}
export const getpreOrder = (param) => {
    return post('/api/fe/order/preOrder', param)
}
export const queryOrderStatus = (param) => {
    return get('/api/fe/order/query', {params: param})
}
export const queryUseListLevels = (param) => {
    return get('/api/fe/order/userLevels', {params: param})
}

// 分享
export const queryNewList = (param) => {
    return post('/api/share/user-list', param)
}
// export const queryShareQrcode = (param) => {
//     return get('/api/fe/order/userLevels', {params: param})
// }

// 登录相关
export const doLogin = (param) => {
    return post('/api/user/pwd-login', param)
}
export const doLoginByMsg = (param) => {
    return post('/api/user/sms-login', param)
}

export const getPublickKey = () => {
    return get('/api/v1/key')
}

export const isRequireGraphic = (param) => {
    return post('/api/v1/need-captcha', param)
}
export const getCaptcha = (param) => {
    return get('/api/v1/captcha', {params: param})
}
export const getSms = (param) => {
    return post('/api/v1/sendSms', param)
}

export const doRegister = (param) => {
    return post('/api/user/reg', param)
}

// 个人中心

export const getResourceUploadUlr = (param) => {
    return get('/api/v1/upload', { params: param })
}

export const getUserInfo = (param) => {
    return get('/api/user/info', { params: param })
}

export const changeMobile = (param) => {
    return post('/api/user/change-mobile', param)
}

export const getSmsWithNoMobile = (param) => {
    return post('/api/user/send-sms', param)
}

export const editPwd = (param) => {
    return post('/api/user/pwd-reset', param)
}

export const resetPwd = (param) => {
    return post('/api/user/pwd-forget', param)
}

export const upDateUserInfo = (param) => {
    return post('/api/user/info/store', param)
}

export const getAuthList = (param) => {
    return get('/api/user/rights', { params: param })
}

export const loginOut = (param) => {
    return post('/api/user/logout')
}
export const getLocations = (param) => {
    return get('/api/region/tree')
}
export const getImgUploadUrl = () => {
    return get('/api/file-upload', {params: {type: 'image', chuck: 0}})
}

export const getUploadUrl = (param) => {
    return get('/api/v1/upload-url', {params: param})
}

export const uploadImg = (param) => {
    return post(param.url, param.data)
}

export const designerApply = (param) => {
    return post('/api/designer/apply', param)
}

export const designerWorkList = (param) => {
    return get('/api/designer/work/list', {params: param})
}

export const designerInfo = (part) => {
    return get('/api/designer/form-info/' + part)
}
export const saveData = (param) => {
    return post('/api/designer/info/store', param)
}

export const designerState = () => {
    return get('/api/designer/auth/state')
}

export const designerAuth = (param) => {
    return post('/api/designer/auth/certify', param)
}

export const designerCardInfo = (param) => {
    return post('/api/designer/card/info', param)
}

export const toHome = (param) => {
    return post('/api/designer/work/home', param)
}

export const homeCancel = (id) => {
    return post('/api/designer/work/cancel/' + id)
}

export const workDetail = (id) => {
    return get('/api/designer/work/detail/' + id)
}

export const workStore = (param) => {
    return post('/api/designer/work/store', param)
}

export const workDestroy = (id) => {
    return post('/api/designer/work/destroy/' + id)
}



// WEBPACK FOOTER //
// ./src/api/index.js